import { render } from "./sms-recepients-select.component.vue?vue&type=template&id=17082c7f&scoped=true"
import script from "./sms-recepients-select.component.vue?vue&type=script&lang=js"
export * from "./sms-recepients-select.component.vue?vue&type=script&lang=js"

import "./sms-recepients-select.component.vue?vue&type=style&index=0&id=17082c7f&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17082c7f"]])

export default __exports__